<template>
  <div class="r-cancel-modal">
    <Modal footer-hide v-model="show" width="652">
      <div class="password-box">
        <div class="change-password common-flex">
          <div class="iconfont iconjinggao"></div>
          <div>{{ $t("order.prompt") }}</div>
        </div>
        <div class="cancel-tip">{{ config.content }}</div>
        <div class="common-flex common-flex-end">
          <div class="back common-hover" @click="cancel">
            {{ config.cancel }}
          </div>
          <div class="submit common-hover" @click="confrims">{{ config.confirm }}</div>
        </div>
      </div>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "r-cancel-modal",
  data() {
    return {
      show: false,
    };
  },
  methods:{
    // 取消訂單
    cancel(){
      this.$emit('cancel')
      this.show = false
    },
  
    confrims(){
      this.$emit('confrim')
    }
  },

  watch: {
    cancelShow: {
      handler(newval, oldval) {
        "newval", newval;
        this.show = newval;
      },
      immediate: true,
    },
    show: {
      handler(newval, oldval) {
        if (newval == false) {
          this.$emit("handlerCancelShow", newval);
        }
      },
      immediate: true,
    },
  },
  props: {
    cancelShow: Boolean,
    spinShow: Boolean,
    config:Object
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
// .r-cancel-modal{
/deep/.ivu-input {
  border: none;
}
.password-box {
  height: 219px;
  width: 620px;
  padding: 14px 24px;
  .back,
  .submit {
    width: 116px;
    height: 40px;
    background: #b5bac4;
    line-height: 40px;
    font-size: 14px;
    font-family: Roboto, Roboto-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
  .current-balance {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 16px;
  }
  .current-price {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #0a4dcc;
    line-height: 16px;
  }
  .submit {
    background: #0a4dcc;
    margin-left: 14px;
  }
  .change-password {
    color: #d87508;
    font-size: 30px;
    font-family: Times, Times-Bold;
    font-weight: 700;
    text-align: left;
    color: #d87508;
    line-height: 37px;
    .iconjinggao {
      margin-right: 10px;
      font-size: 24px;
    }
  }
  .cancel-tip {
    font-size: 20px;
    font-family: Roboto, Roboto-Medium;
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 24px;
    margin: 30px 0 60px 36px;
  }
}
// }
</style>


// WEBPACK FOOTER //
// src/components/r-confirm-modal.vue